var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.entitySummaries &&
    _vm.entitySummaries.length === 0 &&
    _vm.ecomType === "audanet"
      ? _c("div", [
          _vm._v(" Insurer "),
          _c("span", { staticClass: "has-text-primary has-text-weight-bold" }, [
            _vm._v(_vm._s(_vm.insurerName)),
          ]),
          _vm._v(" cannot be not found. Continuing will create this insurer. "),
        ])
      : _c(
          "div",
          [
            _vm.insurerName
              ? _c(
                  "notification-box",
                  { staticClass: "mb-3", attrs: { type: "info" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "is-size-6",
                        attrs: { slot: "text-content" },
                        slot: "text-content",
                      },
                      [
                        _vm._v(' This request for quote is from "'),
                        _c("b", [_vm._v(_vm._s(_vm.insurerName))]),
                        _vm._v('". '),
                        _c("p", [
                          _vm._v(
                            " If you cannot find it in the list of insurers, "
                          ),
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.handleCreateNewInsurer.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v("create a new insurer")]
                          ),
                          _vm._v(". "),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.enableEcomTypeSelection
              ? _c("div", { staticClass: "is-narrow" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("E-Com Type")]),
                  _c("div", { staticClass: "control" }, [
                    _c("div", { staticClass: "field is-horizontal is-flex" }, [
                      _c("div", { staticClass: "control select" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.innerEcomType,
                                expression: "innerEcomType",
                              },
                            ],
                            staticClass: "select-width",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.innerEcomType = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { value: "all" },
                                domProps: {
                                  selected: _vm.innerEcomType == "all",
                                },
                              },
                              [_vm._v("ALL")]
                            ),
                            _c(
                              "option",
                              { domProps: { value: _vm.ecomTypeEnum.ORM } },
                              [_vm._v("ORM")]
                            ),
                            _c(
                              "option",
                              { domProps: { value: _vm.ecomTypeEnum.PNET } },
                              [_vm._v("PNET")]
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "control" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.innerInsurerName,
                              expression: "innerInsurerName",
                            },
                          ],
                          staticClass: "input",
                          attrs: { type: "text", placeholder: "Insurer Name" },
                          domProps: { value: _vm.innerInsurerName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.innerInsurerName = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "control" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-primary",
                            on: { click: _vm.handleSearch },
                          },
                          [_vm._m(0), _c("span", [_vm._v("Search")])]
                        ),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _c("label", { staticClass: "label" }, [
              _vm._v("Please select an insurer"),
            ]),
            _c(
              "bulma-table",
              {
                staticClass:
                  "table is-bordered is-striped is-narrow is-fullwidth",
                attrs: {
                  columns: _vm.columns,
                  "page-index": _vm.filter.pageIndex,
                  "page-size": _vm.filter.pageSize,
                  "total-rows": _vm.totalRows,
                  "is-loading": _vm.isTableLoading,
                  "sort-column": _vm.filter.sortColumn,
                  "sort-order": _vm.filter.sortOrder,
                  "show-pagination": true,
                },
                on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
              },
              [
                _vm._l(_vm.entitySummaries, function (entity, index) {
                  return _c(
                    "tr",
                    {
                      key: entity.messageId,
                      class: { "is-selected": _vm.selectedRow === index },
                      on: {
                        click: function ($event) {
                          return _vm.highlightSelected(index, $event)
                        },
                      },
                    },
                    [
                      _c("td", [_vm._v(" " + _vm._s(entity.name) + " ")]),
                      _c("td", { staticClass: "has-text-centered" }, [
                        _vm._v(" " + _vm._s(entity.repairerId) + " "),
                      ]),
                      _c("td", { staticClass: "has-text-centered" }, [
                        _c(
                          "span",
                          {
                            staticClass: "tag",
                            class: [
                              entity.quotingMethod === "D"
                                ? "is-success"
                                : "is-info",
                            ],
                          },
                          [_vm._v(_vm._s(entity.quotingMethod))]
                        ),
                      ]),
                    ]
                  )
                }),
                _c("template", { slot: "empty" }, [
                  _c("section", { staticClass: "section" }, [
                    _c(
                      "div",
                      {
                        staticClass: "content has-text-grey has-text-centered",
                      },
                      [
                        _c("span", { attrs: { icon: "icon is-large" } }, [
                          _c("i", {
                            staticClass: "mdi mdi-48px mdi-emoticon-sad",
                          }),
                        ]),
                        _c("p", [_vm._v("Nothing")]),
                      ]
                    ),
                  ]),
                ]),
              ],
              2
            ),
            _vm.$v.loadOptions.insurerId.$error
              ? _c("span", { staticClass: "has-text-danger" }, [
                  _vm._m(1),
                  _vm._v(" Please select an insurer before continuing. "),
                ])
              : _vm._e(),
            _vm.entitySummaries && _vm.entitySummaries.length === 0
              ? _c("span", { staticClass: "has-text-danger" }, [
                  _vm._m(2),
                  _vm.ecomType === "audanet"
                    ? _c("span", [
                        _vm._v("Cannot find insurer "),
                        _c("span", { staticClass: "has-text-weight-bold" }, [
                          _vm._v(_vm._s(_vm.insurerName)),
                        ]),
                      ])
                    : _c("span", [
                        _vm._v(
                          "Cannot find insurers that has been setup for " +
                            _vm._s(_vm.ecomType.toUpperCase())
                        ),
                      ]),
                ])
              : _vm._e(),
          ],
          1
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-magnify" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-danger" }, [
      _c("i", { staticClass: "mdi mdi-alert-octagram mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-danger" }, [
      _c("i", { staticClass: "mdi mdi-alert-octagram mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }